import { Alert, Form, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import { useTaxOffice } from '../../lib/useTaxOffice'
import { TaxOfficeSelect } from './TaxOfficeSelect'

export function TaxOfficeFormItem({ county, taxId, required: forced = false }) {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  const { taxOfficeNumber: derived } = useTaxOffice({ county, taxId })

  const required = forced || (Boolean(taxId) && !derived)

  return (
    <Form.Item
      label={t('frontend:company.taxOfficeNumber')}
      name={['accounting', 'taxOfficeNumber']}
      dependencies={[['accounting', 'taxId']]}
      extra={
        <Alert
          type="info"
          showIcon
          style={{ marginTop: token.marginXS }}
          message={
            derived
              ? t('frontend:company.taxOfficeNumberDerived')
              : t('frontend:company.taxOfficeNumberHint')
          }
        />
      }
      getValueProps={(value) => ({ value: derived ?? value })}
      rules={[
        {
          required,
          message: t('frontend:company.taxOfficeNumberRequired'),
        },
      ]}
    >
      <TaxOfficeSelect disabled={Boolean(derived)} />
    </Form.Item>
  )
}
